/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.tradeNo" placeholder="输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户邮箱"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">确定</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column prop="productId" label="ID" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="username" label="用户邮箱" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="orderNo" label="订单号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="payMent" label="支付方式" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="totalFee" label="支付金额" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="title" label="商品名称" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag type="success" size="small" v-if="scope.row.orderStatus == '已支付'">{{ scope.row.orderStatus }}</el-tag>
          <el-tag type="danger" size="small" v-else>{{ scope.row.orderStatus }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.createTime | timestampToTime }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { OrderList } from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      title: '预览',
      formInline: {
        tradeNo: '',
        pageNo: 1,
        pageSize: 15,
        userName: ''
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      OrderList(parameter)
        .then(res => {
          this.loading = false
          this.listData = res.data.lists
          // 分页赋值
          this.pageparm.currentPage = res.data.pageNo
          this.pageparm.pageSize = res.data.pageSize
          this.pageparm.total = res.data.count
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage
      this.formInline.pageSize = parm.pageSize

      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 1
      this.getdata(this.formInline)
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Order.vue